import type { DS_TData } from '../DS/DS.Data'
import { Translations } from '../../../shared/i18n/Translations'

export function I18N_localize(path: string, substitutions: Array<string | number> = [], _?: DS_TData) {
    if (!substitutions?.length) {
        return Translations.t(`app:${path}`)
    }

    if (substitutions?.length === 1) {
        return Translations.t(`app:${path}`, { value: substitutions[0] })
    }

    const interpolation: { [key: string]: string | number } = {}

    for (let i = 0; i < substitutions.length; i++) {
        let key = 'value'

        if (i > 0) {
            key += i
        }

        interpolation[key] = substitutions[i]
    }

    return Translations.t(`app:${path}`, interpolation)
}
